import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output, TemplateRef } from '@angular/core';
import { Employee, EmployeesEmployeesEmployeeModel, EmployeeSlim } from '@coin/shared/core/util-models';
import moment from 'moment';
import { Observable } from 'rxjs';

@Component({
  selector: 'coin-siemens-energy-employee-preview',
  templateUrl: './employee-preview.component.html',
  styleUrls: ['./employee-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    '[class.truncate]': 'truncate()'
  }
})
export class EmployeePreviewComponent {
  @Input() thirdLineTemplate?: TemplateRef<unknown>;
  @Input() boldName = true;
  @Input() showPreferredName: 'never' | 'ifAvailable' | 'preferredAndFull' = 'never';
  @Input() light = false;
  @Input() big = false;
  @Input() small = false;
  @Input() tiny = false;
  @Input() noWrap? = false;
  @Input() wrap? = false;
  @Input() singleLine = true;
  truncate = input(false);
  @Input() showGid = false;
  @Input() showOrgCode = true;
  @Input() showFlag = true;
  @Input() positionClass?: number;
  @Input() smallerPositionClass = false;
  @Input() subTitle?: string;
  @Input() actionButtonTitle?: string;
  @Input() showActionButton = false;
  @Input() actionIcon = 'person_add';
  @Input() showHintIfNoPositionClassSet = false;
  @Input() placeholderText: string;
  @Input() imageIcon: string;
  @Input() idKey = 'GID';
  @Input() isOrgCodeEditable = false;
  @Input() namePrefix: string;
  @Input() customTopInfo: string[];
  @Input() customSubInfo: string[];
  @Input() showExitDateWarning = false;
  @Input() overwriteOrgCode: string;
  @Input() lazyLoadOrgCodesFn: (search: string) => Observable<string[]>;
  @Input() hideText = false;

  employee = input.required({
    transform: (employee: Employee | EmployeesEmployeesEmployeeModel): Employee => {
      return employee as Employee;
    }
  });

  @Output() orgCodeChanged = new EventEmitter<string>();
  @Output() action = new EventEmitter<void>();

  public country(employee: Employee): string {
    return employee?.countryCode ?? employee?.placeOfAction ?? employee?.country;
  }

  public get roleNames(): string[] {
    return (this.employee() as EmployeeSlim)?.roleNames || [];
  }

  public get showPlaceholder(): boolean {
    const emp = this.employee();
    return !emp && !!this.placeholderText;
  }

  public get formattedCompanyExitDate(): string {
    const emp = this.employee();
    if (!emp?.companyExitDate) return '';

    return moment(emp.companyExitDate).format('MM/DD/YYYY');
  }

  public onActionClick(): void {
    this.action.emit();
  }
}
